<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <modal :open="open" @close="close()">
    <template v-slot:modelcontent>
      <div>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900">Choose Organisation</h3>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">

          <select v-model="selectedClient"
                  class="col-span-2 mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            <option v-for="client in clients" :key="client.id" v-bind:value="client">{{ client.name }}</option>
          </select>

          <button
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
              @click="close"
              ref="cancelButtonRef">Cancel
          </button>

          <button-loading
              @click="switchClient"
              :loading="isProcessing"
              buttonlabel="Choose Organisation"
              buttonlabelloading="Processing..."
          ></button-loading>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {CheckIcon} from '@heroicons/vue/outline'

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
      default: true
    },
    switchendpoint: {
      type: String,
      required: true,
    },
    clients: {
      type: Object
    }
  },
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon,
  },
  data: function () {
    return {
      isProcessing: false,
      selectedClient: null
    };
  },
  methods: {
    close: function () {
      if (this.isProcessing === false) {
        this.$emit('closed', false);
      }
    },
    switchClient: function () {
      let self = this;
      if (
          this.selectedClient !== null
          && this.isProcessing === false) {

        this.isProcessing = true;
        window
            .axios
            .post(this.switchendpoint,
                {
                  clientID: this.selectedClient.id
                })
            .then(response => {
              if (response.data.hasOwnProperty('success')) {
                window.location = '/';
              }
            });
      }
    }
  }
}
</script>
